/* global window, document, Tabulator */

(function (window, document) {
    var root = document.getElementById('radar-density-root');
    if (!root) return;

    function qs(sel, el) { return (el || document).querySelector(sel); }
    function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
    function setStatus(msg) {
        var el = qs('[data-radar-status]', root);
        if (el) el.textContent = msg || '';
    }

    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var client = new window.AppaltiMap.ApiGatewayClient({
        baseUrl: apiBase,
        tokenStore: new window.AppaltiMap.TokenStore('appaltimap_auth')
    });

    var VG_RADAR_DENSITY_MODE_STORAGE_KEY = 'vg-radar-density-mode';
    var _vgRadarDensityGatewaySessionOk = false;
    var _vgRadarDensityCompanyBundle = null;
    var _vgRadarDensityLastMode = null;

    function persistRadarDensityMode(mode) {
        try {
            if (mode === 'company' || mode === 'explore') {
                localStorage.setItem(VG_RADAR_DENSITY_MODE_STORAGE_KEY, mode);
            }
        } catch (e) {}
    }

    function loadRadarDensityMode() {
        try {
            var m = localStorage.getItem(VG_RADAR_DENSITY_MODE_STORAGE_KEY);
            return m === 'company' ? 'company' : 'explore';
        } catch (e) {
            return 'explore';
        }
    }

    function fetchGhostSessionToken() {
        return fetch('/members/api/session/', { method: 'GET', credentials: 'include' })
            .then(function (r) {
                if (r.status === 204) return null;
                if (!r.ok) {
                    return r.text().then(function (t) {
                        throw new Error('Ghost session HTTP ' + r.status + (t ? ' ' + t.slice(0, 120) : ''));
                    });
                }
                return r.text();
            })
            .then(function (token) {
                token = (token || '').trim();
                return token || null;
            });
    }

    function gatewaySessionLogin(sessionToken) {
        if (!apiBase) return Promise.reject(new Error('API base mancante'));
        return fetch(apiBase + '/auth/ghost/session/login', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ session_token: sessionToken })
        }).then(function (r) {
            return r.json().then(function (data) {
                if (!r.ok) {
                    var d = (data && data.detail) ? String(data.detail) : '';
                    throw new Error(d || ('Gateway login HTTP ' + r.status));
                }
                return data;
            });
        });
    }

    function ensureGatewaySession() {
        if (_vgRadarDensityGatewaySessionOk) return Promise.resolve();
        return fetchGhostSessionToken()
            .then(function (token) {
                if (!token) throw new Error('Accedi per caricare il profilo aziendale');
                return gatewaySessionLogin(token);
            })
            .then(function () {
                _vgRadarDensityGatewaySessionOk = true;
            });
    }

    function companyCpvPrefixesFromBundle(cpvItems) {
        var out = [];
        (cpvItems || []).forEach(function (it) {
            var raw = it && (it.cpv_code || it.code || it.cpv || it.value);
            var p = stripTrailingZerosToPrefix(raw || '');
            if (p && out.indexOf(p) === -1) out.push(p);
        });
        return out;
    }

    function fetchCompanyBundleForRadarDensity() {
        if (_vgRadarDensityCompanyBundle) return Promise.resolve(_vgRadarDensityCompanyBundle);
        return ensureGatewaySession()
            .then(function () {
                return fetch(apiBase + '/company-profiles?limit=1&offset=0', {
                    credentials: 'include',
                    headers: { Accept: 'application/json' }
                });
            })
            .then(function (r) {
                return r.json().then(function (j) {
                    if (!r.ok) throw new Error((j && j.detail && String(j.detail)) || ('HTTP ' + r.status));
                    return j;
                });
            })
            .then(function (list) {
                var items = (list && list.items) ? list.items : [];
                if (!items.length) return { profileId: null, territories: [], cpv: [] };
                var pid = items[0].id;
                return fetch(apiBase + '/company-profiles/' + encodeURIComponent(pid) + '/bundle', {
                    credentials: 'include',
                    headers: { Accept: 'application/json' }
                })
                    .then(function (r2) {
                        return r2.json().then(function (j2) {
                            if (!r2.ok) throw new Error((j2 && j2.detail && String(j2.detail)) || ('HTTP ' + r2.status));
                            return j2;
                        });
                    })
                    .then(function (bundle) {
                        return {
                            profileId: pid,
                            territories: (bundle && bundle.territories) ? bundle.territories : [],
                            cpv: (bundle && bundle.cpv) ? bundle.cpv : []
                        };
                    });
            })
            .then(function (b) {
                _vgRadarDensityCompanyBundle = b;
                return b;
            })
            .catch(function () {
                _vgRadarDensityCompanyBundle = { profileId: null, territories: [], cpv: [] };
                return _vgRadarDensityCompanyBundle;
            });
    }

    function radarDensityJsonHeaders() {
        var headers = { Accept: 'application/json' };
        var token = client.tokenStore && typeof client.tokenStore.getToken === 'function' ? client.tokenStore.getToken() : '';
        if (token) headers.Authorization = 'Bearer ' + token;
        return headers;
    }

    function sanitizeSlug(v) {
        if (!v || typeof v !== 'string') return '';
        return v.toLowerCase().trim()
            .replace(/[^a-z0-9\-]/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
    }

    function escHtml(s) {
        if (s == null) return '';
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function procedureUrlForTender(t) {
        var base = (root.getAttribute('data-site-url') || '').trim();
        if (!base) {
            base = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : 'https://vistagare.it';
        }
        var procId = (t && t.procedure_id) ? String(t.procedure_id) : '';
        if (!procId) return '';
        var slug = sanitizeSlug(procId);
        return slug ? (base.replace(/\/+$/, '') + '/procedura-' + slug + '/') : '';
    }

    // Minimal helper on client if missing (older bundle).
    if (!client.get) {
        client.get = function (url) {
            var headers = { Accept: 'application/json' };
            return fetch(url, { headers: headers }).then(function (r) { if (!r.ok) throw r; return r.json(); });
        };
    }

    function pad2(n) { return (n < 10 ? '0' : '') + n; }
    function toISODate(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }
    function parseISODate(s) {
        var t = String(s || '').trim();
        if (!t) return null;
        var m = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!m) return null;
        return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    }

    function parseEuroNumber(v) {
        if (v == null || v === '') return NaN;
        if (typeof v === 'number' && isFinite(v)) return v;
        var s = String(v).trim().replace(/\s/g, '');
        if (!s) return NaN;
        if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) return parseFloat(s.replace(/\./g, '').replace(',', '.'), 10);
        if (s.indexOf(',') !== -1) return parseFloat(s.replace(',', '.'), 10);
        return parseFloat(s, 10);
    }
    function formatEuroIt(v) {
        var n = parseEuroNumber(v);
        if (!isFinite(n)) return '—';
        return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function mdRenderSimple(text) {
        var s = String(text || '');
        if (!s) return '';
        try {
            if (typeof marked !== 'undefined' && marked && typeof marked.parse === 'function') {
                var html = marked.parse(s, { breaks: true, gfm: true });
                if (typeof DOMPurify !== 'undefined' && DOMPurify && typeof DOMPurify.sanitize === 'function') {
                    html = DOMPurify.sanitize(html, {
                        USE_PROFILES: { html: true },
                        ADD_TAGS: ['span', 'details', 'summary', 'div'],
                        ADD_ATTR: ['title', 'open'],
                        ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'target', 'rel', 'class', 'id', 'aria-label', 'role']
                    });
                }
                return html;
            }
        } catch (e) {}
        return '<p>' + escHtml(s).replace(/\n/g, '<br>') + '</p>';
    }

    function periodSummaryMarkdown(ps) {
        if (!ps || !ps.count) return '';
        var c = ps.count;
        var a = ps.amount || {};
        var bullets = [];
        if (c.peak_day) bullets.push('Picco **numero gare**: ' + c.peak_day + ' (' + c.peak_value + ' gare)');
        if (a.peak_day) bullets.push('Picco **importi**: ' + a.peak_day + ' (' + formatEuroIt(a.peak_value_eur) + ')');
        if (c.avg_per_day != null) bullets.push('Media giornaliera: **' + c.avg_per_day + '** gare');
        if (a.avg_per_day_eur != null) bullets.push('Media importi/giorno: **' + formatEuroIt(a.avg_per_day_eur) + '**');
        if (c.delta_pct_vs_prev != null) {
            bullets.push('Gare vs periodo precedente: **' + (c.delta_pct_vs_prev > 0 ? '+' : '') + c.delta_pct_vs_prev + '%**');
        }
        if (a.delta_pct_vs_prev != null) {
            bullets.push('Importi vs periodo precedente: **' + (a.delta_pct_vs_prev > 0 ? '+' : '') + a.delta_pct_vs_prev + '%**');
        }
        if (!bullets.length) return '';
        return '### Sintesi periodo\n\n- ' + bullets.join('\n- ');
    }

    function initDefaultDatesIfEmpty() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var df = form.querySelector('input[name="date_from"]');
        var dt = form.querySelector('input[name="date_to"]');
        if (!df || !dt) return;
        if (String(df.value || '').trim() || String(dt.value || '').trim()) return;
        var now = new Date();
        var jan1 = new Date(now.getFullYear(), 0, 1);
        df.value = toISODate(jan1);
        dt.value = toISODate(new Date(now.getFullYear(), 11, 31));
    }

    function readFilters() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return {};
        var fd = new FormData(form);
        var out = {};
        ['date_from', 'date_to'].forEach(function (k) {
            var v = fd.get(k);
            if (v != null && String(v).trim() !== '') out[k] = String(v).trim();
        });
        var mem = (root.getAttribute('data-member-uuid') || '').trim();
        if (mem) out.member = mem;

        var companyCb = form.querySelector('#radar-density-company-mode');
        var inCompany = !!(companyCb && companyCb.checked);

        if (inCompany) {
            var b = _vgRadarDensityCompanyBundle;
            var prefs = companyCpvPrefixesFromBundle(b && b.cpv);
            if (prefs && prefs.length) {
                out.cpv_prefixes = prefs.join(',');
            }
            var terrCb = document.getElementById('radar-density-in-saved-area');
            if (terrCb && terrCb.checked) {
                out.company_mode = '1';
            }
            return out;
        }

        var cpv = fd.get('cpv');
        if (cpv != null && String(cpv).trim() !== '') out.cpv = String(cpv).trim();

        var areaCb = document.getElementById('radar-density-in-saved-area');
        if (areaCb && areaCb.checked && !areaCb.disabled) {
            out.in_saved_area = '1';
        }
        return out;
    }

    function uncheckSavedAreaIfAuthOrAreaError(status) {
        if (status !== 400 && status !== 401) return;
        var cb = document.getElementById('radar-density-in-saved-area');
        if (cb && cb.checked) cb.checked = false;
    }

    function initSavedAreaFromMap() {
        var uuid = (root.getAttribute('data-member-uuid') || '').trim();
        var cb = document.getElementById('radar-density-in-saved-area');
        var hint = document.getElementById('radar-density-area-hint');
        var form = qs('[data-radar-filters]', root);
        var companyCb = form ? form.querySelector('#radar-density-company-mode') : null;
        if (companyCb && companyCb.checked) {
            return Promise.resolve();
        }
        if (!cb) return Promise.resolve();
        if (!uuid) {
            cb.disabled = true;
            if (hint) {
                hint.hidden = false;
                hint.textContent = 'UUID membro non disponibile: impossibile verificare l’area sulla mappa.';
            }
            return Promise.resolve();
        }
        return fetch(apiBase + '/telegram/settings?member=' + encodeURIComponent(uuid), {
            headers: { Accept: 'application/json' }
        })
            .then(function (r) { return r.ok ? r.json() : {}; })
            .then(function (data) {
                var hasArea = data && data.mode === 'area' && data.area && data.area.geojson;
                if (hasArea) {
                    cb.disabled = false;
                    if (hint) { hint.hidden = true; hint.textContent = ''; }
                } else {
                    cb.disabled = true;
                    cb.checked = false;
                    if (hint) {
                        hint.hidden = false;
                        hint.textContent = 'Salva un’area sulla mappa principale (strumento disegno) per abilitare questo filtro.';
                    }
                }
            })
            .catch(function () {
                cb.disabled = true;
                if (hint) {
                    hint.hidden = false;
                    hint.textContent = 'Impossibile verificare se hai un’area salvata sulla mappa.';
                }
            });
    }

    function stripTrailingZerosToPrefix(code) {
        var s = String(code || '').replace(/\D/g, '');
        if (!s) return '';
        if (s.length > 8) s = s.slice(0, 8);
        s = s.replace(/0+$/g, '');
        return s || String(code || '').replace(/\D/g, '').slice(0, 8);
    }

    function initCpvAutocomplete() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var input = form.querySelector('input[name="cpv_query"]');
        var hidden = form.querySelector('input[name="cpv"]');
        var clearBtn = form.querySelector('[data-cpv-clear]');
        var list = document.getElementById('radar-density-cpv-list');
        if (!input || !hidden || !list) return;
        var memberUuid = (root.getAttribute('data-member-uuid') || '').trim();

        var lastFetch = 0;
        var pending;
        var saveTimer;

        function persistCpv(prefix) {
            if (!memberUuid) return;
            if (saveTimer) window.clearTimeout(saveTimer);
            saveTimer = window.setTimeout(function () {
                fetch(apiBase + '/telegram/cpv', {
                    method: 'POST',
                    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
                    body: JSON.stringify({ member_uuid: memberUuid, cpv_prefix: prefix || null })
                }).catch(function () {});
            }, 220);
        }

        function syncClearBtn() {
            if (!clearBtn) return;
            clearBtn.disabled = !String(hidden.value || '').trim();
        }

        var lastResolvedPrefix = '';
        function resolveAndShowLabel(prefix) {
            var p = String(prefix || '').trim();
            if (!p || p === lastResolvedPrefix) return Promise.resolve();
            lastResolvedPrefix = p;
            var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(p) + '&limit=1';
            return fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : {}; })
                .then(function (data) {
                    var it = data && data.items && data.items[0];
                    if (!it) return;
                    var code = String(it.code_main || '').trim();
                    var label = String(it.label_it || '').trim();
                    if (!code) return;
                    input.value = code + (label ? ' — ' + label : '');
                })
                .catch(function () {});
        }

        function render(items) {
            while (list.firstChild) list.removeChild(list.firstChild);
            (items || []).forEach(function (it) {
                var opt = document.createElement('option');
                var code = it.code_main || '';
                var label = it.label_it || '';
                opt.value = code + (label ? ' — ' + label : '');
                list.appendChild(opt);
            });
        }

        function fetchSuggest(q) {
            var now = Date.now();
            lastFetch = now;
            var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(q) + '&limit=15';
            return fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (r) { if (!r.ok) throw r; return r.json(); })
                .then(function (data) {
                    if (lastFetch !== now) return;
                    render((data && data.items) || []);
                })
                .catch(function () {});
        }

        input.addEventListener('input', function () {
            var q = String(input.value || '').trim();
            if (pending) window.clearTimeout(pending);
            if (q.length < 2 && !/\d/.test(q)) return;
            pending = window.setTimeout(function () { fetchSuggest(q); }, 180);
        });

        input.addEventListener('input', function () {
            var raw = String(input.value || '').trim();
            var digits = raw.replace(/\D/g, '');
            hidden.value = digits ? stripTrailingZerosToPrefix(digits) : '';
            persistCpv(hidden.value);
            syncClearBtn();
        });

        input.addEventListener('blur', function () {
            var raw = String(input.value || '').trim();
            if (!raw) {
                hidden.value = '';
                persistCpv('');
                lastResolvedPrefix = '';
                syncClearBtn();
                return;
            }
            var digits = raw.replace(/\D/g, '');
            if (!digits) return;
            hidden.value = stripTrailingZerosToPrefix(digits);
            persistCpv(hidden.value);
            syncClearBtn();
            resolveAndShowLabel(hidden.value);
        });

        if (clearBtn) {
            clearBtn.addEventListener('click', function () {
                input.value = '';
                hidden.value = '';
                lastResolvedPrefix = '';
                persistCpv('');
                syncClearBtn();
            });
        }

        syncClearBtn();
        if (memberUuid) {
            fetch(apiBase + '/telegram/settings?member=' + encodeURIComponent(memberUuid), { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : {}; })
                .then(function (data) {
                    var companyCb = form.querySelector('#radar-density-company-mode');
                    if (companyCb && companyCb.checked) return;
                    var p = String((data && data.cpv_prefix) || '').trim();
                    if (!p) return;
                    hidden.value = p;
                    syncClearBtn();
                    resolveAndShowLabel(p);
                })
                .catch(function () {});
        }
    }

    function applyCompanyModeUiDensity(mode) {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var chkCompany = form.querySelector('#radar-density-company-mode');
        var chkTerr = document.getElementById('radar-density-in-saved-area');
        var wrapTerr = document.getElementById('radar-density-saved-area-wrap');
        var terrLabelSpan = wrapTerr ? wrapTerr.querySelector('span') : null;
        var cpvInput = form.querySelector('input[name="cpv_query"]');
        var cpvHidden = form.querySelector('input[name="cpv"]');
        var clearBtn = form.querySelector('[data-cpv-clear]');
        var hintCompany = document.getElementById('radar-density-company-hint');

        var TERR_LABEL_EXPLORE = 'Solo bandi nell’area salvata sulla mappa principale';
        var TERR_LABEL_COMPANY = 'Solo territori salvati nel company profile';

        function setCompanyHint(msg, visible) {
            if (!hintCompany) return;
            hintCompany.hidden = !visible;
            hintCompany.textContent = visible ? (msg || '') : '';
        }

        function resetCpvToEmpty() {
            if (cpvHidden) cpvHidden.value = '';
            if (cpvInput) cpvInput.value = '';
            if (clearBtn) clearBtn.disabled = true;
        }

        if (mode !== 'company') {
            if (_vgRadarDensityLastMode === 'company') {
                resetCpvToEmpty();
            }
            if (chkCompany) chkCompany.checked = false;
            if (cpvInput) cpvInput.disabled = false;
            if (clearBtn) clearBtn.disabled = !String((cpvHidden && cpvHidden.value) || '').trim();
            if (terrLabelSpan) terrLabelSpan.textContent = TERR_LABEL_EXPLORE;
            setCompanyHint('', false);
            _vgRadarDensityLastMode = 'explore';
            initSavedAreaFromMap();
            return;
        }

        if (chkCompany) chkCompany.checked = true;
        if (terrLabelSpan) terrLabelSpan.textContent = TERR_LABEL_COMPANY;
        if (chkTerr) chkTerr.disabled = false;

        fetchCompanyBundleForRadarDensity().then(function (b) {
            var territories = (b && b.territories) ? b.territories : [];
            var hasTerritories = territories && territories.length > 0;
            if (!hasTerritories) {
                if (chkCompany) {
                    chkCompany.checked = false;
                    chkCompany.disabled = true;
                }
                setCompanyHint('Company profile: non ci sono territori configurati (aggiungili nel Company Profile).', true);
                persistRadarDensityMode('explore');
                applyCompanyModeUiDensity('explore');
                return;
            }

            if (chkCompany) chkCompany.disabled = false;
            var cpvPrefs = companyCpvPrefixesFromBundle(b && b.cpv);
            if (cpvInput) {
                cpvInput.disabled = true;
                cpvInput.value = cpvPrefs.length ? cpvPrefs.join(', ') : '';
            }
            if (cpvHidden) cpvHidden.value = '';
            if (clearBtn) clearBtn.disabled = true;
            setCompanyHint('', false);
            _vgRadarDensityLastMode = 'company';
        });
    }

    function initCompanyModeToggleDensity() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var chkCompany = form.querySelector('#radar-density-company-mode');
        if (!chkCompany) return;

        chkCompany.disabled = true;

        fetchCompanyBundleForRadarDensity().then(function (b) {
            var territories = (b && b.territories) ? b.territories : [];
            var hasTerritories = territories && territories.length > 0;
            if (!hasTerritories) {
                chkCompany.disabled = true;
                chkCompany.checked = false;
                persistRadarDensityMode('explore');
                applyCompanyModeUiDensity('explore');
                var hintCompany = document.getElementById('radar-density-company-hint');
                if (hintCompany) {
                    hintCompany.hidden = false;
                    hintCompany.textContent = 'Company profile: non ci sono territori configurati (aggiungili nel Company Profile).';
                }
                return;
            }

            chkCompany.disabled = false;
            var mode0 = loadRadarDensityMode();
            chkCompany.checked = mode0 === 'company';
            applyCompanyModeUiDensity(chkCompany.checked ? 'company' : 'explore');
        });

        chkCompany.addEventListener('change', function () {
            var on = !!chkCompany.checked;
            var mode = on ? 'company' : 'explore';
            persistRadarDensityMode(mode);
            applyCompanyModeUiDensity(mode);
            insightPageCache = {};
            loadDensity();
            if (table && selectedDay) {
                table.setData();
            } else if (table) {
                table.clearData();
            }
        });

        var terrCb = document.getElementById('radar-density-in-saved-area');
        if (terrCb) {
            terrCb.addEventListener('change', function () {
                var c = form.querySelector('#radar-density-company-mode');
                if (c && c.checked) {
                    insightPageCache = {};
                    loadDensity();
                    if (table && selectedDay) table.setData();
                }
            });
        }
    }

    function buildLegend(el, clsPrefix, labels) {
        if (!el) return;
        el.innerHTML = '';
        var wrap = document.createElement('div');
        wrap.className = 'radar-density__legend-inner';
        var left = document.createElement('span');
        left.className = 'radar-density__legend-label';
        left.textContent = labels[0];
        var right = document.createElement('span');
        right.className = 'radar-density__legend-label';
        right.textContent = labels[labels.length - 1];
        wrap.appendChild(left);
        var steps = document.createElement('div');
        steps.className = 'radar-density__legend-steps';
        for (var i = 0; i < 5; i++) {
            var s = document.createElement('span');
            s.className = 'radar-density__cell ' + clsPrefix + ' level-' + i;
            s.setAttribute('aria-hidden', 'true');
            steps.appendChild(s);
        }
        wrap.appendChild(steps);
        wrap.appendChild(right);
        el.appendChild(wrap);
    }

    function quantizeLevels(values) {
        // Returns a function v -> level 0..4 (0 means empty/zero)
        var nums = (values || []).filter(function (x) { return isFinite(x) && x > 0; }).sort(function (a, b) { return a - b; });
        if (!nums.length) {
            return function () { return 0; };
        }
        function q(p) {
            var idx = Math.floor((nums.length - 1) * p);
            return nums[Math.max(0, Math.min(nums.length - 1, idx))];
        }
        var t1 = q(0.25);
        var t2 = q(0.50);
        var t3 = q(0.75);
        return function (v) {
            var n = Number(v);
            if (!isFinite(n) || n <= 0) return 0;
            if (n <= t1) return 1;
            if (n <= t2) return 2;
            if (n <= t3) return 3;
            return 4;
        };
    }

    function buildCalendarDays(df, dt) {
        var start = new Date(df.getFullYear(), df.getMonth(), df.getDate());
        var end = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
        // align start to Monday
        var dow = (start.getDay() + 6) % 7; // 0=Mon ..6=Sun
        start.setDate(start.getDate() - dow);
        var days = [];
        for (var d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
            days.push(new Date(d.getFullYear(), d.getMonth(), d.getDate()));
        }
        // extend to Sunday
        var last = days[days.length - 1];
        var lastDow = (last.getDay() + 6) % 7;
        for (var i = lastDow; i < 6; i++) {
            var nd = new Date(last.getFullYear(), last.getMonth(), last.getDate());
            nd.setDate(nd.getDate() + (i - lastDow) + 1);
            days.push(nd);
        }
        return days;
    }

    var MONTHS_IT = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
    var DOW_IT = ['L', 'M', 'M', 'G', 'V', 'S', 'D']; // Lun..Dom

    function renderMonths(monthsEl, windowDf, windowDt, activeDf, activeDt) {
        if (!monthsEl) return;
        monthsEl.innerHTML = '';

        var days = buildCalendarDays(windowDf, windowDt);
        var cols = Math.ceil(days.length / 7);
        monthsEl.style.setProperty('--rd-cols', String(cols));

        function monthLabelFor(dateObj) {
            return MONTHS_IT[dateObj.getMonth()] || '';
        }

        // Build labels aligned to week columns. We label when month changes at the start of a week column.
        var lastMonth = null;
        for (var c = 0; c < cols; c++) {
            var d0 = days[c * 7];
            if (!d0) continue;
            // Use the first in-range day in the column for month detection (avoid leading padding days).
            var pick = null;
            for (var r = 0; r < 7; r++) {
                var dx = days[c * 7 + r];
                if (!dx) continue;
                if (dx >= windowDf && dx <= windowDt) {
                    pick = dx;
                    break;
                }
            }
            if (!pick) continue;
            var m = pick.getMonth();
            if (lastMonth === null || m !== lastMonth) {
                lastMonth = m;
                var lab = document.createElement('span');
                lab.className = 'radar-density__month';
                lab.textContent = monthLabelFor(pick);
                lab.style.gridColumn = String(c + 1);
                // Bold months that intersect the active query range (activeDf..activeDt).
                var monthStart = new Date(pick.getFullYear(), pick.getMonth(), 1);
                var monthEnd = new Date(pick.getFullYear(), pick.getMonth() + 1, 0);
                if (monthEnd >= activeDf && monthStart <= activeDt) {
                    lab.classList.add('is-in-range');
                }
                monthsEl.appendChild(lab);
            }
        }
    }

    function renderDow(dowEl) {
        if (!dowEl) return;
        dowEl.innerHTML = '';
        for (var i = 0; i < 7; i++) {
            var s = document.createElement('span');
            s.className = 'radar-density__dow-letter';
            s.textContent = DOW_IT[i] || '';
            dowEl.appendChild(s);
        }
    }

    function renderHeatmap(gridEl, clsPrefix, windowDf, windowDt, activeDf, activeDt, seriesMap, levelForValue, valueLabelFn, onPickDay, onHoverDay) {
        if (!gridEl) return;
        gridEl.innerHTML = '';

        var days = buildCalendarDays(windowDf, windowDt);
        var cols = Math.ceil(days.length / 7);
        gridEl.style.setProperty('--rd-cols', String(cols));

        var now = new Date();
        var today0 = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        days.forEach(function (d) {
            var isWindowDay = d >= windowDf && d <= windowDt;
            if (!isWindowDay) {
                var empty = document.createElement('span');
                empty.className = 'radar-density__cell is-empty';
                empty.setAttribute('aria-hidden', 'true');
                gridEl.appendChild(empty);
                return;
            }
            var iso = toISODate(d);
            var inRange = d >= activeDf && d <= activeDt;
            var isPast = d < today0;
            var val = seriesMap[iso] != null ? seriesMap[iso] : 0;
            var level = levelForValue(val);
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'radar-density__cell ' + clsPrefix + ' level-' + level + (inRange ? '' : ' is-out') + (isPast ? ' is-past' : '');
            btn.disabled = !inRange;
            btn.setAttribute('data-day', iso);
            var t = iso + ': ' + valueLabelFn(val);
            btn.setAttribute('aria-label', t);
            btn.setAttribute('title', t);
            btn.addEventListener('click', function () {
                if (!inRange) return;
                onPickDay(iso);
            });
            if (typeof onHoverDay === 'function') {
                btn.addEventListener('mouseenter', function () {
                    if (!inRange) return;
                    onHoverDay(iso, btn);
                });
            }
            gridEl.appendChild(btn);
        });
    }

    var selectedDay = null;
    var table;
    var dayInspectorChart = null;
    var insightPageCache = {};
    var hoverInsightTimer = null;

    function dayInsightUrl(dayIso) {
        var f = readFilters();
        f.day = dayIso;
        return apiBase + '/radar/density-tenders/day-insight?' + new URLSearchParams(f).toString();
    }

    function loadDayInsightPage(dayIso, cb) {
        if (insightPageCache[dayIso]) {
            cb(insightPageCache[dayIso]);
            return;
        }
        fetch(dayInsightUrl(dayIso), { headers: radarDensityJsonHeaders() })
            .then(function (r) {
                if (!r.ok) throw r;
                return r.json();
            })
            .then(function (data) {
                var ins = data && data.insight ? data.insight : null;
                if (ins) insightPageCache[dayIso] = ins;
                cb(ins);
            })
            .catch(function () { cb(null); });
    }

    function renderDayInspector(ins) {
        var box = qs('[data-day-inspector]', root);
        var head = qs('[data-day-inspector-head]', root);
        var canvas = qs('[data-day-inspector-chart]', root);
        var topEl = qs('[data-day-inspector-top]', root);
        var cpvEl = qs('[data-day-inspector-cpv]', root);
        if (!box || !head || !canvas) return;
        if (!ins) {
            box.hidden = true;
            return;
        }
        box.hidden = false;
        var pct = ins.top3_amount_share != null ? Math.round(Number(ins.top3_amount_share) * 1000) / 10 : 0;
        head.innerHTML = mdRenderSimple(
            '**' + ins.day_iso + '** · ' + ins.tenders_count + ' gare · Totale ' + formatEuroIt(ins.amount_sum_eur) +
                ' · Media ' + formatEuroIt(ins.amount_avg_eur) + ' · Mediana ' + formatEuroIt(ins.amount_median_eur) +
                ' · Top 3 sul valore: **' + pct + '%**'
        );
        var concHost = box.querySelector('[data-day-inspector-conc]');
        if (!concHost) {
            concHost = document.createElement('div');
            concHost.setAttribute('data-day-inspector-conc', '');
            concHost.className = 'vg-ai-density-conc';
            head.parentNode.insertBefore(concHost, canvas.parentElement);
        }
        var pFill = Math.min(100, Math.max(0, pct));
        concHost.innerHTML = '<div class="vg-ai-density-conc-label">Concentrazione valore (top 3 gare)</div>' +
            '<div class="vg-ai-density-conc-bar" role="progressbar" aria-valuenow="' + pFill + '" aria-valuemin="0" aria-valuemax="100">' +
            '<span style="width:' + pFill + '%"></span></div>';

        if (dayInspectorChart && typeof dayInspectorChart.destroy === 'function') {
            try { dayInspectorChart.destroy(); } catch (eDC) {}
        }
        dayInspectorChart = null;
        if (typeof window.Chart !== 'undefined' && ins.histogram && ins.histogram.length) {
            var labels = ins.histogram.map(function (h) { return h.bucket_label; });
            var counts = ins.histogram.map(function (h) { return Number(h.count || 0); });
            dayInspectorChart = new window.Chart(canvas.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Gare per fascia',
                        data: counts,
                        backgroundColor: 'rgba(37,99,235,0.45)',
                        borderColor: 'rgba(37,99,235,1)',
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: { legend: { display: false } },
                    scales: { y: { beginAtZero: true, ticks: { precision: 0 } } }
                }
            });
        }
        if (topEl) {
            topEl.innerHTML = '';
            if (ins.top_tenders && ins.top_tenders.length) {
                var ul = document.createElement('ul');
                ul.className = 'vg-ai-density-top-tenders';
                ins.top_tenders.forEach(function (t, idx) {
                    var li = document.createElement('li');
                    var amt = formatEuroIt(t.amount_eur);
                    var href = (t.procedure_url_path || '').trim();
                    if (!href) href = procedureUrlForTender(t);
                    var title = escHtml(String(t.title || '—').slice(0, 140));
                    var buyer = escHtml(t.buyer_name || '');
                    li.className = 'vg-density-top-tenders__item';
                    li.innerHTML =
                        '<span class="vg-density-top-rank" aria-hidden="true">' + (idx + 1) + '</span>' +
                        '<span class="vg-density-top-tenders__body">' + amt + (href
                            ? ' — <a href="' + escHtml(href) + '" target="_blank" rel="noopener">' + title + '</a>'
                            : ' — ' + title) + (buyer ? ' <span class="vg-ai-density-buyer">(' + buyer + ')</span>' : '') +
                        '</span>';
                    ul.appendChild(li);
                });
                topEl.appendChild(ul);
            }
        }
        if (cpvEl) {
            if (ins.cpv_breakdown && ins.cpv_breakdown.length) {
                var cpvHtml = '<p class="radar-density__cpv-top-title"><strong>CPV (top)</strong></p><ul class="radar-density__cpv-top-list">';
                ins.cpv_breakdown.forEach(function (r) {
                    var crumb = (r && r.cpv_breadcrumb_html) ? String(r.cpv_breadcrumb_html) : '';
                    if (!crumb) {
                        crumb = '<code class="radar-density__cpv-code-fallback">' + escHtml(r.cpv_prefix || '—') + '</code>';
                    }
                    cpvHtml +=
                        '<li class="radar-density__cpv-top-item">' +
                        '<span class="radar-density__cpv-crumb">' + crumb + '</span>' +
                        ' <span class="radar-density__cpv-top-meta">· ' + formatEuroIt(r.amount_sum_eur) + ' · ' + r.tenders_count + ' gare</span>' +
                        '</li>';
                });
                cpvHtml += '</ul>';
                cpvEl.innerHTML = cpvHtml;
            } else {
                cpvEl.innerHTML = '';
            }
        }
    }

    function onHoverHeatmapDay(dayIso, btn) {
        if (hoverInsightTimer) clearTimeout(hoverInsightTimer);
        hoverInsightTimer = setTimeout(function () {
            loadDayInsightPage(dayIso, function (ins) {
                if (!ins || !btn) return;
                var p = ins.top3_amount_share != null ? Math.round(Number(ins.top3_amount_share) * 1000) / 10 : 0;
                btn.setAttribute('title',
                    dayIso + '\nGare: ' + ins.tenders_count +
                    '\nTotale: ' + formatEuroIt(ins.amount_sum_eur) +
                    '\nMedia: ' + formatEuroIt(ins.amount_avg_eur) +
                    '\nMediana: ' + formatEuroIt(ins.amount_median_eur) +
                    '\nTop3 valore: ' + p + '%');
            });
        }, 220);
    }

    function buildTable() {
        if (typeof Tabulator === 'undefined') {
            setStatus('Tabulator non disponibile.');
            return;
        }
        var el = qs('#radar-density-table', root);
        if (!el || table) return;

        table = new Tabulator(el, {
            layout: 'fitColumns',
            placeholder: 'Seleziona un giorno per vedere le gare',
            rowClick: function (e, row) {
                try {
                    // If the click comes from an existing link, let the browser handle it.
                    var t = e && e.target;
                    if (t && t.closest && t.closest('a')) return;
                    if (t && t.closest && t.closest('[data-vg-kanban-lamp]')) return;
                } catch (ignore) {}
                var data = row && row.getData ? (row.getData() || {}) : {};
                var procUrl = procedureUrlForTender(data);
                if (procUrl) {
                    window.open(procUrl, '_blank', 'noopener');
                    return;
                }
                var tid = data.ted_id ? String(data.ted_id).trim() : '';
                if (tid) {
                    window.open('/ted-' + encodeURIComponent(tid) + '/', '_blank', 'noopener');
                }
            },
            pagination: true,
            paginationMode: 'remote',
            paginationSize: 25,
            paginationSizeSelector: [25, 50, 100],
            paginationInitialPage: 1,
            ajaxURL: apiBase + '/radar/density-tenders/day',
            ajaxParams: function () {
                var f = readFilters();
                if (selectedDay) f.day = selectedDay;
                return f;
            },
            ajaxRequestFunc: function (url, config, params) {
                var headers = radarDensityJsonHeaders();
                // Tabulator triggers an initial load on creation; avoid 422 by short-circuiting until a day is selected.
                if (!selectedDay) {
                    return Promise.resolve({ items: [], total: 0, page: 1, per_page: params && params.size ? params.size : 25 });
                }
                var sep = url.indexOf('?') >= 0 ? '&' : '?';
                var qs2 = new URLSearchParams(params || {}).toString();
                var fullUrl = qs2 ? url + sep + qs2 : url;
                return fetch(fullUrl, { method: 'GET', headers: headers }).then(function (r) {
                    if (!r.ok) {
                        return r.text().then(function (t) {
                            var msg = r.statusText || 'Errore';
                            try {
                                var body = JSON.parse(t);
                                var d = body && body.detail;
                                msg = typeof d === 'string' ? d : d ? JSON.stringify(d) : msg;
                            } catch (ignore) {}
                            setStatus(msg);
                            uncheckSavedAreaIfAuthOrAreaError(r.status);
                            throw new Error(msg);
                        });
                    }
                    return r.json();
                });
            },
            ajaxResponse: function (url, params, response) {
                var perPage = response.per_page || params.size || 25;
                var total = response.total || 0;
                var lastPage = Math.max(1, Math.ceil(total / perPage) || 1);
                return { last_page: lastPage, data: response.items || [] };
            },
            columns: [
                {
                    title: '',
                    field: '_vg_lamp',
                    width: 44,
                    hozAlign: 'center',
                    headerSort: false,
                    formatter: function (c) {
                        return window.VistaGareKanbanLamp
                            ? window.VistaGareKanbanLamp.formatterCell(c.getRow().getData())
                            : '';
                    }
                },
                {
                    title: 'Scadenza',
                    field: 'tender_period_end',
                    width: 130,
                    formatter: function (c) {
                        var v = c.getValue();
                        return v ? String(v).slice(0, 10) : '—';
                    }
                },
                {
                    title: 'Procedura',
                    field: 'procedure_id',
                    width: 170,
                    formatter: function (c) {
                        var row = c.getRow().getData() || {};
                        var procId = row.procedure_id ? String(row.procedure_id).trim() : '';
                        if (!procId) return '—';
                        var url = procedureUrlForTender(row);
                        if (!url) return escHtml(procId);
                        return '<a href="' + escHtml(url) + '" target="_blank" rel="noopener">' + escHtml(procId) + '</a>';
                    }
                },
                {
                    title: 'Titolo',
                    field: 'title',
                    minWidth: 260,
                    formatter: function (c) {
                        var row = c.getRow().getData() || {};
                        var t = row.title || '—';
                        var tid = row.ted_id ? String(row.ted_id).trim() : '';
                        if (!tid) return String(t);
                        var href = '/ted-' + encodeURIComponent(tid) + '/';
                        return '<a href="' + href + '" target="_blank" rel="noopener">' + String(t) + '</a>';
                    }
                },
                { title: 'Ente', field: 'buyer_name', minWidth: 180 },
                {
                    title: 'Importo',
                    field: 'amount',
                    width: 140,
                    hozAlign: 'right',
                    formatter: function (c) { return formatEuroIt(c.getValue()); }
                },
                { title: 'Indirizzo', field: 'address', minWidth: 200 }
            ]
        });
        root._vgTabulator = table;
        if (window.VistaGareKanbanLamp && table) {
            window.VistaGareKanbanLamp.wireTabulator(table);
        }
    }

    function setSelectedDayLabel(dayIso) {
        var el = qs('[data-selected-day]', root);
        if (!el) return;
        if (!dayIso) {
            el.textContent = 'Seleziona un giorno nella heatmap.';
            return;
        }
        el.textContent = 'Gare con scadenza: ' + dayIso;
    }

    function highlightSelectedDay(dayIso) {
        qsa('.radar-density__cell.is-selected', root).forEach(function (b) { b.classList.remove('is-selected'); });
        if (!dayIso) return;
        qsa('.radar-density__cell[data-day="' + dayIso + '"]', root).forEach(function (b) { b.classList.add('is-selected'); });
    }

    function pickDay(dayIso) {
        selectedDay = dayIso;
        setSelectedDayLabel(dayIso);
        highlightSelectedDay(dayIso);
        loadDayInsightPage(dayIso, function (ins) { renderDayInspector(ins); });
        buildTable();
        if (table) table.setData();
    }

    function loadDensity() {
        initDefaultDatesIfEmpty();
        var f = readFilters();
        if (!f.date_from || !f.date_to) {
            setStatus('Imposta Da data e A data.');
            return Promise.resolve();
        }
        setStatus('Caricamento heatmap…');

        var headers = radarDensityJsonHeaders();

        var url = apiBase + '/radar/density-tenders?' + new URLSearchParams(f).toString();
        return fetch(url, { headers: headers })
            .then(function (r) {
                if (!r.ok) {
                    return r.text().then(function (t) {
                        var msg = r.statusText || 'Errore';
                        try {
                            var body = JSON.parse(t);
                            var d = body && body.detail;
                            msg = typeof d === 'string' ? d : d ? JSON.stringify(d) : msg;
                        } catch (ignore) {}
                        setStatus(msg);
                        uncheckSavedAreaIfAuthOrAreaError(r.status);
                        throw new Error(msg);
                    });
                }
                return r.json();
            })
            .then(function (data) {
                var series = (data && data.series) || [];
                var df = parseISODate(f.date_from);
                var dt = parseISODate(f.date_to);
                if (!df || !dt) throw new Error('Date invalid');

                // Always show a 12-month window ending at dt (like GitHub).
                var windowDf = new Date(dt.getFullYear(), dt.getMonth() - 11, 1);
                var windowDt = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());

                var mapCount = {};
                var mapSum = {};
                var counts = [];
                var sums = [];
                series.forEach(function (it) {
                    var d = String(it.date || '').slice(0, 10);
                    var c = Number(it.tenders_count || 0);
                    var s = Number(it.amount_sum || 0);
                    if (!d) return;
                    mapCount[d] = c;
                    mapSum[d] = s;
                    counts.push(c);
                    sums.push(s);
                });

                var levelCount = quantizeLevels(counts);
                var levelSum = quantizeLevels(sums);

                buildLegend(qs('[data-legend="count"]', root), 'rd-count', ['meno gare', 'più gare']);
                buildLegend(qs('[data-legend="amount"]', root), 'rd-amount', ['importo minore', 'importo maggiore']);
                renderMonths(qs('[data-months="count"]', root), windowDf, windowDt, df, dt);
                renderMonths(qs('[data-months="amount"]', root), windowDf, windowDt, df, dt);
                renderDow(qs('[data-dow="count"]', root));
                renderDow(qs('[data-dow="amount"]', root));

                // Show current query summary near each title.
                try {
                    var bits = [];
                    if (f.in_saved_area) bits.push('Area salvata');
                    if (f.company_mode) bits.push('Territori company');
                    if (f.cpv_prefixes) bits.push('CPV multipli');
                    else if (f.cpv) bits.push('CPV ' + String(f.cpv));
                    bits.push(String(f.date_from) + ' → ' + String(f.date_to));
                    var metaTxt = bits.filter(Boolean).join(' · ');
                    var m1 = qs('[data-density-meta="count"]', root);
                    var m2 = qs('[data-density-meta="amount"]', root);
                    if (m1) m1.textContent = metaTxt;
                    if (m2) m2.textContent = metaTxt;
                } catch (eMeta) {}

                try {
                    insightPageCache = {};
                    var psEl = qs('[data-period-insight]', root);
                    if (psEl) {
                        var psMd = periodSummaryMarkdown(data.period_summary);
                        psEl.innerHTML = psMd ? mdRenderSimple(psMd) : '';
                    }
                } catch (ePer) {}

                renderHeatmap(
                    qs('[data-heatmap="count"]', root),
                    'rd-count',
                    windowDf,
                    windowDt,
                    df,
                    dt,
                    mapCount,
                    levelCount,
                    function (v) { return (Number(v) || 0).toLocaleString('it-IT'); },
                    pickDay,
                    onHoverHeatmapDay
                );
                renderHeatmap(
                    qs('[data-heatmap="amount"]', root),
                    'rd-amount',
                    windowDf,
                    windowDt,
                    df,
                    dt,
                    mapSum,
                    levelSum,
                    function (v) { return formatEuroIt(v); },
                    pickDay,
                    onHoverHeatmapDay
                );

                // Reset selection if outside range
                if (selectedDay) {
                    var sd = parseISODate(selectedDay);
                    if (!sd || sd < df || sd > dt) {
                        selectedDay = null;
                        setSelectedDayLabel(null);
                        highlightSelectedDay(null);
                        renderDayInspector(null);
                        if (table) table.clearData();
                    }
                }
                setStatus('');
            })
            .catch(function () {
                if (!String(qs('[data-radar-status]', root).textContent || '').trim()) {
                    setStatus('Impossibile caricare heatmap.');
                }
            });
    }

    function run() {
        initDefaultDatesIfEmpty();
        initSavedAreaFromMap().finally(function () {
            initCpvAutocomplete();
            buildTable();
            setSelectedDayLabel(null);
            initCompanyModeToggleDensity();
            loadDensity();
        });
    }

    var form = qs('[data-radar-filters]', root);
    if (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            insightPageCache = {};
            loadDensity();
            if (table && selectedDay) {
                table.setData();
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})(window, document);

